module.exports = __webpack_public_path__ + "static/media/quality3.53ee96e7.webp";